module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allCategories":"All categories","name":"Name","category":"Category","type":"Type","template":"Template"}}')
  delete Component.options._Ctor
}
